<template>
  <vue-modal-base class="vue-popup-prompt"
                  v-bind="_modalProps"
  >
    <!--Content-->
    <div class="vue-popup-prompt__content"
         v-if="contentAsHtml"
         v-html="content"
    >
    </div>
    <div class="vue-popup-prompt__content"
         v-else
    >
      {{ content }}
    </div>

    <!--Buttons-->
    <div class="vue-popup-prompt__buttons">
      <slot name="buttonSuccess">
        <vue-button class="btn bnt__success btn--green" @click="processSuccess">
          {{ titleSuccess }}
        </vue-button>
      </slot>

      <slot name="buttonCancel">
        <vue-button class="btn btn__cancel btn--brown" @click="processCancel">
          {{ titleCancel }}
        </vue-button>
      </slot>
    </div>
  </vue-modal-base>
</template>

<script>
import VueModalBase from './../Base/App';
import VueButton    from './../../Button/App';

export default {
  name: 'vue-popup-prompt',

  props: {
    modalProps: {
      type: Object,
      required: false,
      default: () => ({})
    },
    contentAsHtml: {
      type: Boolean,
      required: false,
      default: false
    },
    content: {
      type: String,
      required: false,
      default: ``
    },
    showSuccessBtn: {
      type: Boolean,
      required: false,
      default: true
    },
    showCancelBtn: {
      type: Boolean,
      required: false,
      default: true
    },
    successLabel: {
      type: String,
      required: false,
      default: null
    },
    cancelLabel: {
      type: String,
      required: false,
      default: null
    },
    cancelHandlerFn: {
      type: Function,
      required: false,
      default: () => () => undefined
    },
    successHandlerFn: {
      type: Function,
      required: false,
      default: () => () => undefined
    }
  },
  computed: {
    _modalProps() {
      return {
        showTitle: this.modalProps.showTitle ?? VueModalBase.props.showTitle.default,
        showCloseIcon: this.modalProps.showCloseIcon ?? VueModalBase.props.showCloseIcon.default,
        title: this.modalProps.title ?? VueModalBase.props.title.default,
        visible: this.modalProps.visible ?? VueModalBase.props.visible.default,
        closeHandlerFn: this.modalProps.closeHandlerFn ?? VueModalBase.props.closeHandlerFn.default
      };
    },
    titleSuccess() {
      return this.successLabel || this.$t(`Success`);
    },

    titleCancel() {
      return this.cancelLabel || this.$t(`Cancel`);
    }
  },
  methods: {
    processSuccess() {
      this.$emit(`success`);
      this.successHandlerFn && this.successHandlerFn();
    },

    processCancel() {
      this.$emit(`cancel`);
      this.cancelHandlerFn && this.cancelHandlerFn();
    }
  },
  components: {
    VueModalBase,
    VueButton
  }

};
</script>
